'use client'

import { useParams } from 'next/navigation'
import { ReactNode } from 'react'
import { ExternalLinkFragment } from '@/components/DatoLink/ExternalLink.generated'

type ExternalLinkProps = {
	fragment: ExternalLinkFragment
	children: ReactNode
	id?: string
	className?: string
	style?: { [key: string]: string | number }
	inactive?: boolean
	params?: string
	onClick?: React.MouseEventHandler<HTMLAnchorElement>
	locale?: string
}

export default function ExternalLink({
	fragment,
	children,
	id,
	className,
	style,
	inactive = false,
	params,
}: ExternalLinkProps) {
	const { lang } = useParams()

	return (
		<a
			hrefLang={lang ? lang.toString() : 'x-default'}
			href={inactive ? undefined : `${fragment.url}${params ? params : ''}`}
			target={inactive ? undefined : fragment.targetBlank ? '_blank' : '_self'}
			title={inactive ? undefined : fragment.label}
			id={id ?? fragment?.label?.replace(/\s/g, '_').toLowerCase()}
			className={className || ''}
			style={style}
			key={
				inactive
					? undefined
					: fragment.id + String(Math.round(Math.random() * 10000))
			}
		>
			{children}
		</a>
	)
}
